import { areaName } from './weekColors'

/**
 * One polyline-group per (crewId, weekType, dayIndex). Stops sorted by seq.
 */
export function buildDayGroups (stops, days = []) {
  const map = new Map()
  for (const s of stops) {
    const key = `${s.crewId}|${s.weekType}|${s.dayIndex}`
    if (!map.has(key)) {
      map.set(key, { crewId: s.crewId, weekType: s.weekType, dayIndex: s.dayIndex, stops: [] })
    }
    map.get(key).stops.push(s)
  }
  for (const g of map.values()) {
    g.stops.sort((a, b) => a.seq - b.seq)
  }
  const groups = Array.from(map.values())

  // Join geometry per group.
  const geomByKey = new Map()
  for (const d of days) {
    const key = `${d.crewId}|${d.weekType}|${d.dayIndex}`
    geomByKey.set(key, d.geometry)
  }
  for (const group of groups) {
    const k = `${group.crewId}|${group.weekType}|${group.dayIndex}`
    group.geometry = geomByKey.get(k) || null
  }
  return groups
}

/**
 * Five entries (Mon..Fri) with rolled-up counts and centroids.
 * areaName is null for empty days.
 */
export function buildDayStats (stops) {
  const buckets = [0, 1, 2, 3, 4].map(dayIndex => ({
    dayIndex,
    stops: 0,
    serviceMin: 0,
    centroidLat: null,
    centroidLng: null,
    areaName: null,
    _latSum: 0,
    _lngSum: 0
  }))

  for (const s of stops) {
    const b = buckets[s.dayIndex]
    if (!b) continue
    b.stops += 1
    b.serviceMin += s.serviceMin || 0
    b._latSum += s.lat
    b._lngSum += s.lng
  }

  for (const b of buckets) {
    if (b.stops > 0) {
      b.centroidLat = b._latSum / b.stops
      b.centroidLng = b._lngSum / b.stops
      b.areaName = areaName(b.centroidLat, b.centroidLng)
    }
    delete b._latSum
    delete b._lngSum
  }

  return buckets
}
